import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';
import { Card, Col, Row, Breadcrumb, Modal, message, Menu, Button, Icon, Dropdown } from 'antd';
import { CoinStatusPanel } from '../PositionsView/CoinStatusPanel';
import { PositionDetails } from './PositionDetails';
import { OrderDetails } from './OrderDetails';
import { JournalDetails } from './JournalDetails';
import { StrategyDetails } from './StrategyDetails';
import { ARTRebuyModal } from '../PositionsView/ARTRebuyModal';
import { LimitSellModal } from '../PositionsView/LimitSellModal';
import { StopLossModal } from '../PositionsView/StopLossModal';
import { SellStrategyModal } from '../PositionsView/SellStrategyModal';
import { DCAModal } from '../PositionsView/DCAModal';
import { IndicatorDetails } from './IndicatorDetails';

@inject('store')
@withRouter
@observer
export class PositionView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            limitSellModal: false,
            stopLossModal: false,
            sellStrategyModal: false,
            dcaModal: false,
            artModal: false
        };
    }

    async componentDidMount() {
        await this.bindChart(this.props);
    }

    async componentWillReceiveProps(nextProps, nextState, nextContext) {
        await this.bindChart(nextProps);
    }

    async bindChart(props) {
        let position = this.props.store.botStore.positions.filter(
            p => p.id === this.props.match.params.id
        )[0];
        if (!position)
            position = await this.props.store.botStore.positionStore.getPosition(
                this.props.match.params.id
            );

        this.setup(position);
        this.setState({ position });
        if (this.hasInit) this.bindChartOrderLines(position);
    }

    componentWillUnmount() {
        clearInterval(this.getData);
        this.widget.remove();
        this.widget = null;
        this.hasInit = false;
    }

    bindChartOrderLines(position) {
        const { store } = this.props;

        if (!position || !this.widget || !this.hasInit) return;

        if (!this.entry) {
            this.entry = this.widget
                .chart()
                .createPositionLine()
                .setText('ENTRY')
                .setQuantity(position.amount_held)
                .setLineLength(3);
        }

        if (!this.stoploss && position.stop_loss) {
            this.stoploss = this.widget
                .chart()
                .createOrderLine()
                .onModify(function(data, cb) {
                    //noop allows on move to work
                })
                .onMove(function() {
                    store.botStore.actionStore.execute('set_stop_loss', {
                        position_id: position.id,
                        price: this.getPrice()
                    });
                })
                .onCancel(function() {
                    store.botStore.actionStore.execute('set_stop_loss', {
                        position_id: position.id,
                        price: null
                    });
                })
                .setText('STOP LOSS')
                .setQuantity(position.amount_held)
                .setLineLength(3)
                .setPrice(position.stop_loss);
        }

        if (!this.arm && position.sell_strategy_config.type === 'trail') {
            this.arm = this.widget
                .chart()
                .createPositionLine()
                .setText('ARM')
                .setBodyTextColor('#fff')
                .setLineLength(3)
                .setQuantity(null)
                .setPrice(position.arm_target);

            this.tsl = this.widget
                .chart()
                .createPositionLine()
                .setText('TSL')
                .setBodyTextColor('#fff')
                .setLineLength(3)
                .setQuantity(null)
                .setPrice(position.arm_stop_loss);
        }

        if (!this.arm && !this.exit) {
            this.exit = this.widget
                .chart()
                .createOrderLine()
                .onModify(function(data, cb) {
                    //noop allows on move to work
                })
                .onMove(function() {
                    store.botStore.actionStore.execute('user_sell', {
                        position_id: position.id,
                        price: this.getPrice()
                    });
                })
                .setText(
                    position.is_manual_sell
                        ? 'TAKE PROFIT'
                        : position.sell_strategy_config.type.replace(/_/g, '').toUpperCase()
                )
                .setQuantity(position.amount_held)
                .setLineLength(3)
                .setPrice(position.target_price);
        }

        if (this.stoploss && !position.stop_loss) this.stoploss.remove();
        if (this.exit) this.exit.setPrice(position.target_price);

        if (this.tsl) {
            const armActiveColor = position.arm_armed ? '#fbbc06' : '#29c0b1';
            this.arm
                .setBodyBorderColor(armActiveColor)
                .setBodyBackgroundColor(armActiveColor)
                .setLineColor(armActiveColor);

            const tslActiveColor = position.arm_armed ? '#ff3366' : '#29c0b1';
            this.tsl
                .setBodyBorderColor(tslActiveColor)
                .setBodyBackgroundColor(tslActiveColor)
                .setLineColor(tslActiveColor);
            this.tsl.setPrice(position.arm_stop_loss);
        }

        this.entry.setPrice(position.avg_buy_price);
        this.entry.setQuantity(position.amount_held);
    }

    setup(position) {
        const { store } = this.props;
        if (!position || this.hasInit) return;

        this.widget = new window.TradingView.widget({
            //debug: true, // uncomment this line to see Library errors and warnings in the console
            fullscreen: false,
            symbol: position.marketId,
            interval: '30',
            container_id: 'chart',
            datafeed: {
                onReady(cb) {
                    cb();
                },

                resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
                    onSymbolResolvedCallback({
                        name: symbolName,
                        supported_resolutions: ['1', '3', '5', '15', '30'],
                        has_intraday: true,
                        minmov: 1,
                        pricescale: 100000000
                    });
                },
                getBars: async (
                    symbolInfo,
                    resolution,
                    from,
                    to,
                    onHistoryCallback,
                    onErrorCallback,
                    firstDataRequest
                ) => {
                    if (firstDataRequest) {
                        const candles = await store.botStore.getKline(symbolInfo.name, resolution);
                        onHistoryCallback(candles);
                    }
                },
                subscribeBars: async (
                    symbolInfo,
                    resolution,
                    onRealtimeCallback,
                    subscriberUID,
                    onResetCacheNeededCallback
                ) => {
                    this.getData = setInterval(async () => {
                        const candles = await store.botStore.getKline(symbolInfo.name, resolution);
                        onRealtimeCallback(candles[candles.length - 1]);
                    }, 3000);
                },
                unsubscribeBars() {
                    clearInterval(this.getData);
                }
            },

            library_path: '/charting_library/',
            locale: 'en',
            disabled_features: ['study_templates', 'header_symbol_search', 'header_compare'],
            enabled_features: [''],
            charts_storage_url: 'http://saveload.tradingview.com',
            charts_storage_api_version: '1.1',
            client_id: 'apextrader.io',
            user_id: 'user1',
            autosize: true,
            theme: 'dark'
        });

        this.widget.headerReady().then(() => {
            const button = this.widget.createButton();
            button.setAttribute('title', 'Add Stop Loss');
            button.addEventListener('click', () => {
                this.setState({ stopLossModal: true });
            });
            button.textContent = 'Add Stop Loss';
        });

        const self = this;
        this.widget.onChartReady(() => {
            self.hasInit = true;
            this.bindChartOrderLines(position);

            position.buy_orders &&
                position.buy_orders.forEach(t => {
                    this.widget
                        .chart()
                        .createExecutionShape()
                        .setText(`@${t.avg_price} Buy ${t.amount}`)
                        .setTooltip(`@${t.avg_price} Buy ${t.amount}`)
                        .setTextColor('#29c0b1')
                        .setArrowColor('#29c0b1')
                        .setDirection('buy')
                        .setTime(t.timestamp / 1000)
                        .setPrice(t.avg_price);
                });

            position.sell_orders &&
                position.sell_orders.forEach(t => {
                    this.widget
                        .chart()
                        .createExecutionShape()
                        .setText(`@${t.price} Sell ${t.amount}`)
                        .setTooltip(`@${t.price} Sell ${t.amount}`)
                        .setTextColor('#ff3366')
                        .setArrowColor('#ff3366')
                        .setDirection('sell')
                        .setTime(t.timestamp / 1000)
                        .setPrice(t.price);
                });
        });
    }

    renderBreadcrumb() {
        const position = this.state.position;

        if (!position) return null;

        const isBlacklisted =
            this.props.store.botStore.currentConfiguration.blacklisted_coins.indexOf(
                position.marketId
            ) >= 0;

        const menu = (
            <Menu onClick={this.handleMenuSelect.bind(this)}>
                <Menu.Item key="view_chart">View Chart</Menu.Item>
                <Menu.Item
                    disabled={
                        !position.active ||
                        position.status === 'BUY_ORDER_PLACED' ||
                        position.status === 'PLACING_BUY_ORDER' ||
                        position.status === 'REVERSING'
                    }
                    key="market_sell_position"
                >
                    Market Sell
                </Menu.Item>
                <Menu.Item
                    disabled={
                        !position.active ||
                        position.status === 'BUY_ORDER_PLACED' ||
                        position.status === 'PLACING_BUY_ORDER' ||
                        position.status === 'REVERSING'
                    }
                    key="limit_sell_position"
                >
                    Limit Sell
                </Menu.Item>
                <Menu.Item
                    disabled={
                        !position.active ||
                        position.status === 'BUY_ORDER_PLACED' ||
                        position.status === 'PLACING_BUY_ORDER' ||
                        position.status === 'REVERSING'
                    }
                    key="dca_position"
                >
                    DCA Position
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item
                    disabled={
                        !position.active ||
                        position.status === 'BUY_ORDER_PLACED' ||
                        position.status === 'PLACING_BUY_ORDER' ||
                        position.status === 'REVERSING'
                    }
                    key="set_sell_strategy"
                >
                    Set Sell Strategy
                </Menu.Item>
                <Menu.Item
                    disabled={
                        !position.active ||
                        position.status === 'BUY_ORDER_PLACED' ||
                        position.status === 'PLACING_BUY_ORDER' ||
                        position.status === 'REVERSING'
                    }
                    key="set_stop_loss"
                >
                    Set Stop Loss
                </Menu.Item>
                <Menu.Item
                    disabled={position.status !== 'REVERSING'}
                    key="rebuy_reversing_position"
                >
                    Rebuy Reversing Position
                </Menu.Item>
                <Menu.Item
                    disabled={position.status !== 'REVERSING'}
                    key="close_reversing_position"
                >
                    Close Reversing Position
                </Menu.Item>
                <Menu.Item
                    disabled={
                        !position.active ||
                        position.status === 'BUY_ORDER_PLACED' ||
                        position.status === 'PLACING_BUY_ORDER' ||
                        position.status === 'REVERSING'
                    }
                    key="toggle_sell_on_ta_status_bulk"
                >
                    Toggle SOTA Status
                </Menu.Item>
                <Menu.Item
                    disabled={
                        !position.active ||
                        position.status === 'BUY_ORDER_PLACED' ||
                        position.status === 'PLACING_BUY_ORDER' ||
                        position.status === 'REVERSING'
                    }
                    key="toggle_auto_dca_status_bulk"
                >
                    Toggle Auto DCA Status
                </Menu.Item>
                <Menu.Item
                    disabled={
                        !position.active ||
                        position.status === 'BUY_ORDER_PLACED' ||
                        position.status === 'PLACING_BUY_ORDER'
                    }
                    key="toggle_auto_reverse_status_bulk"
                >
                    Toggle Auto Reverse Status
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="blacklist_coin">
                    {isBlacklisted ? 'Remove from' : 'Add to'} Blacklist
                </Menu.Item>
                <Menu.Item disabled={position.status === 'PLACING_BUY_ORDER'} key="delete_position">
                    Delete Position
                </Menu.Item>
            </Menu>
        );

        return (
            <div className={'breadcrumb'}>
                <div style={{ width: '50%', display: 'inline-block' }}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to={`/a/bot/${this.props.match.params.botId}/performance`}>
                                Home
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link to={`/a/bot/${this.props.match.params.botId}/positions`}>
                                Positions
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>{position.id}</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div style={{ textAlign: 'right', width: '50%', display: 'inline-block' }}>
                    <Dropdown overlay={menu}>
                        <Button ghost type={'primary'}>
                            Actions <Icon type="down" />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        );
    }

    handleMenuSelect(selection) {
        const position = this.state.position;
        const path = selection.keyPath.reverse();
        const key = path[0];

        switch (key) {
            case 'market_sell_position':
                Modal.confirm({
                    title: 'Do you want to Market sell this position?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('user_sell', {
                            position_id: position.id,
                            price: null
                        });
                        this.setState({ selectedRows: [] });
                    }
                });
                return;
            case 'limit_sell_position':
                this.setState({ limitSellModal: true });
                return;
            case 'set_sell_strategy':
                this.setState({ sellStrategyModal: true });
                return;
            case 'set_stop_loss':
                this.setState({ stopLossModal: true });
                return;
            case 'dca_position':
                this.setState({ dcaModal: true });
                return;
            case 'delete_position':
                console.log(position);
                Modal.confirm({
                    title: 'Do you want to delete this position?',
                    content: 'Position will be removed and orders cancelled on the exchange',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('delete_position', {
                            position_id: position.id
                        });
                        this.setState({ selectedRows: [] });
                    }
                });
                return;
            case 'view_chart':
                window.open(
                    `https://uk.tradingview.com/chart?symbol=binance%3A${position.baseId}${position.quoteId}`,
                    '_blank'
                );
                return;
            case 'toggle_sell_on_ta_status_bulk':
                Modal.confirm({
                    title: 'Toggle Sell on TA status?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute(
                            'toggle_sell_on_ta_status_bulk',
                            { position_ids: [position.id] }
                        );
                    }
                });
                return;
            case 'toggle_auto_dca_status_bulk':
                Modal.confirm({
                    title: 'Toggle DCA status?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute(
                            'toggle_auto_dca_status_bulk',
                            { position_ids: [position.id] }
                        );
                        this.setState({ selectedRows: [] });
                    }
                });
                return;
            case 'toggle_auto_reverse_status_bulk':
                Modal.confirm({
                    title: 'Toggle Auto Reverse status?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute(
                            'toggle_auto_reverse_status_bulk',
                            { position_ids: [position.id] }
                        );
                        this.setState({ selectedRows: [] });
                    }
                });
                return;
            case 'blacklist_coin':
                const idx = this.props.store.botStore.currentConfiguration.blacklisted_coins.indexOf(
                    position.marketId
                );
                const next = [...this.props.store.botStore.currentConfiguration.blacklisted_coins];
                if (idx >= 0) {
                    next.splice(idx, 1);
                    message.success(`${position.marketId} removed from blacklist`);
                } else {
                    next.push(position.marketId);
                    message.success(`${position.marketId} added to blacklist`);
                }
                this.props.store.botStore.updateConfigValue('blacklisted_coins', next);
                return;
            case 'close_reversing_position':
                Modal.confirm({
                    title: 'Close reversing position?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('close_reversing_position', {
                            position_id: position.id
                        });
                        this.setState({ selectedRows: [] });
                    }
                });
                return;
            case 'rebuy_reversing_position':
                this.setState({ artModal: true });
                return;
            default: //noop
        }
    }

    render() {
        const position =
            this.props.store.botStore.positions.filter(
                p => p.id === this.props.match.params.id
            )[0] || this.state.position;
        this.bindChartOrderLines(position);
        return (
            <div>
                {this.renderBreadcrumb()}

                <Card style={{ height: 750, marginBottom: 24 }} bodyStyle={{ height: '100%' }}>
                    <div id="chart" style={{ height: '100%' }} />
                </Card>

                <Row gutter={24}>
                    <Col xs={24} md={12}>
                        <CoinStatusPanel record={position} />
                        <PositionDetails position={position} />
                        <StrategyDetails position={position} />
                        <IndicatorDetails position={position} />
                    </Col>
                    <Col xs={24} md={12}>
                        <JournalDetails position={position} />
                    </Col>
                </Row>
                <Row gutter={24} style={{ marginTop: 24 }}>
                    <Col xs={24}>
                        <OrderDetails position={position} />
                    </Col>
                </Row>

                <ARTRebuyModal
                    visible={this.state.artModal}
                    onCancel={() => this.setState({ artModal: false })}
                    position={position}
                />
                <LimitSellModal
                    visible={this.state.limitSellModal}
                    onCancel={() => this.setState({ limitSellModal: false })}
                    position={position}
                />
                <StopLossModal
                    visible={this.state.stopLossModal}
                    onCancel={() => {
                        this.setState({ stopLossModal: false });
                    }}
                    position={position}
                />
                <SellStrategyModal
                    visible={this.state.sellStrategyModal}
                    onCancel={() => this.setState({ sellStrategyModal: false })}
                    position={position}
                />
                <DCAModal
                    visible={this.state.dcaModal}
                    onCancel={() => this.setState({ dcaModal: false })}
                    position={position}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionView/index.js